<template>
    <div class="block px-4 py-10 pb-12 mx-auto -mt-32 sm:hidden max-w-7xl sm:px-6 lg:px-8">
        <div class="overflow-hidden bg-white rounded-md shadow">
            <div class="py-4 bg-gray-200 shadow-sm rounded-t-md">
                <table class="table w-full text-sm text-indigo-700 uppercase table-fixed">
                    <thead>
                        <tr>
                            <th class="font-normal">
                                <button
                                    @click="today"
                                    class="px-4 py-2 font-semibold bg-transparent border border-indigo-500 rounded hover:bg-indigo-500 hover:text-white hover:border-transparent"
                                >
                                    OGGI
                                </button>
                            </th>
                        </tr>
                    </thead>
                </table>
            </div>

            <div class="flex flex-col">
                <div class="py-2 -my-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                    <div class="relative inline-block min-w-full overflow-hidden align-middle border-b border-gray-200 shadow main-container">
                        <div
                            class="scrollable timeline-container"
                            @scroll="scroll"
                        >
                            <section
                                v-for="appointment in appointments"
                                :key="appointment.id"
                                :name="isToday(appointment.date)? 'today': ''"
                                @click="examination(appointment)"
                                class="p-3 ml-10"
                            >
                                <div class="container w-full">
                                    <div class="cd-timeline__block">
                                        <div class="relative pl-3 -ml-3 timeline-content">
                                            <h2>{{ appointment.title}}</h2>
                                            <div class="flex items-center justify-between">
                                                <span class="text-gray-600">{{ appointment.date | prettydate}} {{ appointment.start | prettyhour}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <calendar-modal
            v-if="openModal"
            :open="openModal"
            :appointment="appointment"
            @dismiss="openModal= false"
            @save="save"
        ></calendar-modal>
    </div>
</template>

<style lang="scss" scoped>
.main-container {
    &::before {
        content: "";
        position: absolute;
        top: 0;
        height: 100%;
        width: 4px;
        @apply bg-indigo-700;
        @apply ml-5;
    }

    .timeline-content {
        &:before {
            content: "";
            position: absolute;
            top: 16px;
            right: 100%;
            width: 0;
            height: 0;
            border: 7px solid transparent;
            border-right-color: #5145cd;
        }
    }
}
</style>

<script type="text/javascript">
import { mapState } from "vuex";

import CalendarAppointment from "./CalendarAppointment.vue";
import CalendarModal from "./CalendarModal";

export default {
    data: () => {
        return {
            appointment: {},
            showAllDay: false,
            startHour: 9,
            endHour: 19,
            hours: [],
            scrollTop: 0,
            openModal: false
        };
    },

    components: {
        CalendarAppointment,
        CalendarModal
    },

    computed: {
        ...mapState("calendar", {
            day: "day",
            appointments: "timeline"
        }),
        daysOfWeek() {
            var tmpDate = window.moment(this.date).startOf("isoWeek");
            var days = [];
            days.push(tmpDate.format("ddd DD/MM/YYYY"));
            for (let interval = 0; interval < 4; interval++) {
                days.push(tmpDate.add(1, "d").format("ddd DD/MM/YYYY"));
            }
            return days;
        }
    },

    methods: {
        today() {
            $('[name="today"]').scrollIntoView();
        },

        isToday(date) {
            return (
                moment(date).format("DDMMYYYY") == moment().format("DDMMYYYY")
            );
        },

        create(day, hour, minutes) {
            var tmp_date = window
                .moment(this.date)
                .startOf("isoWeek")
                .add(day, "d")
                .startOf("day");
            this.appointment = {
                date: tmp_date.format("YYYY-MM-DD"),
                start: tmp_date
                    .add(hour, "h")
                    .add(minutes, "m")
                    .format("HH:mm"),
                end: tmp_date.add("30", "m").format("HH:mm")
            };
            $("#appointment_modal")
                .modal({ autofocus: false })
                .modal("toggle");
        },
        examination(appointment) {
            if (appointment.type == "examination") {
                this.$router.push(
                    `/patients/${appointment.record_id}/examination/${appointment.id}`
                );
            }
        },
        save() {
            if (this.appointment.id) {
                this.$store.dispatch("calendar/update", {
                    appointment: this.appointment,
                    week: {
                        year: this.date.format("Y"),
                        week: this.date.format("w")
                    }
                });
            } else {
                this.$store.dispatch("calendar/create", {
                    appointment: this.appointment,
                    week: {
                        year: this.date.format("Y"),
                        week: this.date.format("w")
                    }
                });
            }
        },
        remove(data) {
            this.$store.dispatch("calendar/DELETE", {
                appointment: this.appointments[data.index],
                week: {
                    year: this.date.format("Y"),
                    week: this.date.format("w")
                }
            });
        },
        scroll: _.throttle(function() {
            let container = $(".scrollable");
            let height = container.scrollHeight - container.offsetHeight;
            let scrollTop = container.scrollTop;
            if (scrollTop < 100 && this.scrollTop > scrollTop) {
                let first = this.appointments.length
                    ? this.appointments[0]
                    : null;
                this.$store.dispatch(
                    "calendar/PREV_TIMELINE",
                    window.moment(first ? first.date : null)
                );
            }
            if (height - scrollTop < 100 && this.scrollTop < scrollTop) {
                let last = this.appointments.slice(-1);
                this.$store.dispatch(
                    "calendar/NEXT_TIMELINE",
                    window.moment(last ? last.date : null)
                );
            }
            this.scrollTop = scrollTop;
        }, 500)
    },

    created() {
        for (let hour = this.startHour; hour <= this.endHour; hour++) {
            this.hours.push(hour);
        }
        if (this.day == null) {
            this.$store.dispatch("calendar/TIMELINE", window.moment());
        }
    }
};
</script>
